import { AnyAction } from '@reduxjs/toolkit';
import { produce } from 'immer';
import { ThunkResult } from '.';

export interface StateShape {
    documentType: 'pdf' | 'web' | 'pptx';
    originalHostname: string;
    baseUrl: string;
    url: string;
}

const defaultState: StateShape = {
    documentType: 'web',
    originalHostname: '',
    baseUrl: '',
    url: '',
};

const SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE';

export const actionCreators = {
    setDocumentType:
        (documentType: string): ThunkResult<Promise<void>> =>
        async (dispatch) => {
            dispatch({ type: SET_DOCUMENT_TYPE, documentType });
        },
};

export const appReducer = (state = defaultState, action: AnyAction): StateShape => {
    switch (action.type) {
        case SET_DOCUMENT_TYPE: {
            return produce(state, (draft) => {
                draft.documentType = action.documentType;
            });
        }
        default:
            return state;
    }
};
